import type { OrganizationRankingResponseRankingResponseRelatedPagedData } from '@on3/api';
import { Avatar } from '@on3/ui-lib/components/Avatar';
import { Link } from '@on3/ui-lib/components/Link';
import { useSite } from '@on3/ui-lib/index';
import { createUrl } from '@on3/ui-lib/utils/url';
import { SideModuleWrapper } from '@public/components/UI/Layout/Containers/Sidebar/SideModuleWrapper';

import styles from './TeamModule.module.scss';

interface ITeamModuleListProps {
  teamRanking: OrganizationRankingResponseRankingResponseRelatedPagedData;
  selectedSport: string;
}
export const TeamModule = ({
  teamRanking,
  selectedSport,
}: ITeamModuleListProps) => {
  const { defaultYears } = useSite();
  const { footballRecruitingYear, nonFootballRecruitingYear } = defaultYears;
  const recruitingYear =
    selectedSport === 'basketball'
      ? nonFootballRecruitingYear
      : footballRecruitingYear;

  const { list } = teamRanking ?? {};
  const viewAllTeam = `/rivals/rankings/industry-team/${selectedSport}/${recruitingYear}/`;

  return (
    <SideModuleWrapper
      className={styles.container}
      title="Team Recruiting Rankings"
    >
      <ol>
        {list?.slice(0, 10).map((item) => {
          const {
            key,
            organization,
            appliedAverageConsensusRating,
            overallConsensusRank,
            appliedTotalConsensusRating,
            dispayConsensusScore,
          } = item;

          return (
            <li key={key}>
              <Link
                className={styles.fanitem}
                href={createUrl([
                  'college',
                  organization?.slug,
                  selectedSport,
                  recruitingYear,
                  'industry-comparison-commits',
                ])}
              >
                <span className={styles.rank}>{overallConsensusRank}</span>
                <figure>
                  <Avatar
                    domain={organization?.asset?.domain}
                    height={30}
                    source={organization?.asset?.source}
                    teamAvatar
                    title={organization?.fullName}
                    type={organization?.asset?.type}
                    width={30}
                  />
                </figure>
                <div className={styles.fanWrapper}>
                  <span className={styles.teamName}>{organization?.name}</span>
                  {appliedAverageConsensusRating && (
                    <div className={styles.teamAvg}>
                      <span>Avg.</span>
                      <span>{appliedTotalConsensusRating?.toFixed(2)}</span>
                    </div>
                  )}
                </div>

                <span className={styles.totalRating}>
                  {dispayConsensusScore?.toFixed(2)}
                </span>
              </Link>
            </li>
          );
        })}
      </ol>
      <footer>
        <Link className={styles.viewAll} href={viewAllTeam}>
          View all
        </Link>
      </footer>
    </SideModuleWrapper>
  );
};
